'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0005 10.9928C19.0005 15.9635 14.9709 19.993 10.0002 19.993C5.02955 19.993 1 15.9635 1 10.9928C1 6.0221 5.02955 1.99255 10.0002 1.99255C14.9709 1.99255 19.0005 6.0221 19.0005 10.9928ZM11.2024 7.41453C11.2024 8.07851 10.6641 8.61678 10.0001 8.61678C9.33612 8.61678 8.79785 8.07851 8.79785 7.41453C8.79785 6.75055 9.33612 6.21228 10.0001 6.21228C10.6641 6.21228 11.2024 6.75055 11.2024 7.41453ZM10.001 9.73792C10.5533 9.73792 11.001 10.1856 11.001 10.7379V15.0139C11.001 15.5662 10.5533 16.0139 10.001 16.0139C9.44869 16.0139 9.00098 15.5662 9.00098 15.0139V10.7379C9.00098 10.1856 9.44869 9.73792 10.001 9.73792Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
